import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from '../icon-navigation.css';

/**
 * Default icon size when menu is horizontal
 * @type {string}
 */
const horizontalIconSize = '32px';
/**
 * Default icon size when menu is vertical
 * @type {string}
 */
const verticalIconSize = '42px';

/**
 * Default navigation identifier when menu is horizontal
 * @type {string}
 */

export const navIdentifier = 'nav-';

/**
 * Default icon data attribute name when menu is vertical
 * @type {string}
 */
const verticalIconDataTracking = `mob-${navIdentifier}`;

const RouteIcon = ({ direction, icon, dataQa }) => {
    if (!icon) return null;

    const iconSize = direction === 'horizontal' ? horizontalIconSize : verticalIconSize;
    const dataName = direction === 'horizontal' ? navIdentifier : verticalIconDataTracking;

    const svgDirectionClass = direction === 'horizontal' ? styles.svgHorizontal : styles.svgVertical;
    const loadAnimation = icon && icon.loadAnimation;
    const svgClass = cx(loadAnimation, styles.svgIcon, svgDirectionClass);

    return (
        <span className={svgClass}>
            {React.createElement(icon.svg, {
                size: iconSize,
                height: iconSize,
                width: iconSize,
                'data-tracking': `${dataName}${dataQa}`,
            })}
        </span>
    );
};

RouteIcon.propTypes = {
    direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
    icon: PropTypes.object,
    dataQa: PropTypes.string.isRequired,
};

RouteIcon.defaultProps = {
    icon: PropTypes.null,
};

export default RouteIcon;
